import * as React from "react";
const SvgSignalCellular2Bar = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.3,
  d: "M2 22h20V2L2 22z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 10 2 22h12V10z",
  fill: "currentColor"
}));
export default SvgSignalCellular2Bar;